import { render, staticRenderFns } from "./CreateOrderPayment.vue?vue&type=template&id=4de1a8ae&"
import script from "./CreateOrderPayment.vue?vue&type=script&lang=js&"
export * from "./CreateOrderPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports